export const GET_NOTE_LIST = "GET_NOTE_LIST";
export const NOTE_PROCESSING = "NOTE_PROCESSING";
export const STOP_NOTE_PROCESSING = "STOP_NOTE_PROCESSING";
